import { render, staticRenderFns } from "./WarehouseFulfillments.vue?vue&type=template&id=6dd7d624&scoped=true"
import script from "./WarehouseFulfillments.vue?vue&type=script&lang=js"
export * from "./WarehouseFulfillments.vue?vue&type=script&lang=js"
import style0 from "./WarehouseFulfillments.vue?vue&type=style&index=0&id=6dd7d624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd7d624",
  null
  
)

export default component.exports